import React from "react";
import { motion } from "framer-motion";
import { Wand2, Clock, ShieldCheck } from "lucide-react";
import { fadeUp, viewportOnce } from "../../lib/ui";

const PILLARS = [
  {
    no: "01",
    title: "Transition Edits",
    icon: Wand2,
    bg: "bg-clay-surface",
    desc: "High-impact, visually seamless transformation Reels showcasing before/after looks and product applications that stop the scroll.",
    tag: "before / after",
  },
  {
    no: "02",
    title: "Shift-Ready GRWMs",
    icon: Clock,
    bg: "bg-clay-lime",
    desc: "‘Get Ready With Me’ routines built for long-wear, fresh-looking beauty that holds up through the most demanding 12-hour days.",
    tag: "long-wear",
  },
  {
    no: "03",
    title: "Wear-Tests & Honest Reviews",
    icon: ShieldCheck,
    bg: "bg-clay-pink/20",
    desc: "Real-time performance checks under daily conditions — authentic, trusted recommendations made for my peers, not the algorithm.",
    tag: "honest",
  },
];

export const Pillars = () => {
  return (
    <section id="pillars" data-testid="pillars-section" className="px-4 py-20 sm:px-6 sm:py-28">
      <div className="mx-auto max-w-6xl">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mb-12 max-w-2xl"
        >
          <span className="font-body text-sm font-bold uppercase tracking-widest text-clay-violet">
            The Manifesto
          </span>
          <h2 className="mt-3 font-display text-4xl font-black tracking-tighter text-clay-ink sm:text-6xl">
            Content pillars I live by.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-7 md:grid-cols-3">
          {PILLARS.map((p, i) => (
            <motion.article
              key={p.no}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewportOnce}
              className={`group flex flex-col rounded-[2.25rem] border-[3px] border-clay-ink ${p.bg} p-7 shadow-clay`}
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl font-black text-clay-ink/15">
                  {p.no}
                </span>
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl border-[3px] border-clay-ink bg-white shadow-brutal-sm transition-transform group-hover:-rotate-6">
                  <p.icon className="h-6 w-6 text-clay-violetdeep" strokeWidth={2.25} />
                </span>
              </div>
              <h3 className="mt-6 font-display text-2xl font-black leading-tight tracking-tight text-clay-ink">
                {p.title}
              </h3>
              <p className="mt-3 flex-1 font-body text-sm font-medium leading-relaxed text-clay-ink/75">
                {p.desc}
              </p>
              <span className="mt-6 inline-flex w-fit rounded-full border-2 border-clay-ink bg-white px-3 py-1 font-body text-xs font-bold uppercase tracking-wider text-clay-ink">
                #{p.tag}
              </span>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
